// Convention day labels — single source of truth used by the admin timeslot
// creator and the signups date filter. Update here if dates ever change.
export const AVAILABLE_DAYS = [
  { label: 'Thu Jul 9',  date: '2026-07-09' },
  { label: 'Fri Jul 10', date: '2026-07-10' },
  { label: 'Sat Jul 11', date: '2026-07-11' },
  { label: 'Sun Jul 12', date: '2026-07-12' },
  { label: 'Mon Jul 13', date: '2026-07-13' },
];
